// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs__container___292hf","item":"Tabs__item___1wtFU","is-active":"Tabs__is-active___TOQUc","is-disabled":"Tabs__is-disabled___1vPmX","prefix":"Tabs__prefix___3oQOA"};